<template>
  <router-view />
</template>


<script>
</script>

<style>
html,body,#app{
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

html.dark {
  background-color: #161b22;
}
</style>
